import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import Components from 'components';
import Plugins from 'plugins';
import IntlyVideo from 'components/intly-video';
import lib from './components/lib';
import Context from './components/Context';
import IntlyPaddle from './components/intly-paddle';

let addContext = [(el) => IntlyPaddle(el)];

document.addEventListener('DOMContentLoaded', () => {
    new Context({ target: '.paddle-parent' }, addContext);
});


// Initialise Alpine
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.start();

// block specific scripts (see /blocks/block.example.js)
// e.g. import "blocks/hero/hero001"

jQuery(function($) {
    Components.init();
    Plugins.init();
});


// Extend Marquees
// This behaviour is for marquees with multiple elements
// that need to be animated
// -- START Marquee Modifier
const marquees = document.querySelectorAll('.marquee');
marquees.forEach(marquee => {
    let content = marquee.querySelector('div');
    let clone = content.cloneNode(true);
    marquee.appendChild(clone);

    let contentWidth = content.offsetWidth;
    content.style.transform = `translateX(${contentWidth}px)`;

    marquee.querySelectorAll('div').forEach(div => {
        div.style.animationDuration = `${(contentWidth / 100) * 2}s`;
    });
});
// -- END Marquee Modifier



lib.qsa('.has-background.has-primary-background-color, .has-background.has-grey-background-color, .has-background.has-tertiary-background-color').forEach(el => {
    el.classList.add('box-expand');
    el.classList.add('--viewport');
   
    // create element and append the expander
    let expander = document.createElement('div');
    expander.classList.add('--expander');
    expander.classList.add('z-0');
    el.appendChild(expander);
});


// Function to handle intersection changes
// -- START Intersection Observer
const handleIntersection = (entries, observer) => {
    entries.forEach(entry => {
        let element = entry.target;
        if (entry.isIntersecting) {
            element.classList.add('--in-viewport');
            element.classList.add('--has-viewport');
        } else {
            element.classList.remove('--in-viewport');
        }
    });
}

// Initialize Intersection Observer
let observer = new IntersectionObserver(handleIntersection, {
    threshold: 0.1 
});

// Observe Elements
let elementsToObserve = document.querySelectorAll('.--viewport');
elementsToObserve.forEach(element => {
    observer.observe(element);
});
// -- END Intersection Observer


// Initialize Vimeo
document.querySelectorAll(".intly-video").forEach((root) => {
    new IntlyVideo(root);
});




// Start INLINE VIDEO // MP4 ONlY
const videos = lib.qsa('.inline-video');

videos.forEach(function(videoContainer) {
    const video = videoContainer.querySelector('video');
    const playButton = videoContainer.querySelector('.play-btn');
    const pauseButton = videoContainer.querySelector('.pause-btn');


    pauseButton.style.display = 'none';

    // Play button click event
    playButton.addEventListener('click', function(e) {
        e.preventDefault();
        video.play(); 
        playButton.style.display = 'none';
        pauseButton.style.display = 'flex';
    });

    // Pause button click event
    pauseButton.addEventListener('click', function(e) {
        e.preventDefault(); 
        video.pause();
        playButton.style.display = 'flex';
        pauseButton.style.display = 'none'; 
    });
});
// END INLINE VIDEO







function initMap( $el ) {

    // Find marker elements within map.
    var $markers = $el.find('.marker');

    // Create gerenic map.
    var mapArgs = {
        zoom        : $el.data('zoom') || 16,
        mapTypeId   : google.maps.MapTypeId.ROADMAP
    };
    var map = new google.maps.Map( $el[0], mapArgs );

    // Add markers.
    map.markers = [];
    $markers.each(function(){
        initMarker( jQuery(this), map );
    });

    // Center map based on markers.
    centerMap( map );

    // Return map instance.
    return map;
}

/**
 * initMarker
 *
 * Creates a marker for the given jQuery element and map.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @param   object The map instance.
 * @return  object The marker instance.
 */
function initMarker( $marker, map ) {

    // Get position from marker.
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var latLng = {
        lat: parseFloat( lat ),
        lng: parseFloat( lng )
    };

    // Create marker instance.
    var marker = new google.maps.Marker({
        position : latLng,
        map: map
    });

    // Append to reference for later use.
    map.markers.push( marker );

    // If marker contains HTML, add it to an infoWindow.
    if( $marker.html() ){

        // Create info window.
        var infowindow = new google.maps.InfoWindow({
            content: $marker.html()
        });

        // Show info window when marker is clicked.
        google.maps.event.addListener(marker, 'click', function() {
            infowindow.open( map, marker );
        });
    }
}

/**
 * centerMap
 *
 * Centers the map showing all markers in view.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   object The map instance.
 * @return  void
 */
function centerMap( map ) {

    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function( marker ){
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    // Case: Single marker.
    if( map.markers.length == 1 ){
        map.setCenter( bounds.getCenter() );

    // Case: Multiple markers.
    } else{
        map.fitBounds( bounds );
    }
}

// Render maps on page load.
jQuery(document).ready(function(){
    jQuery('.acf-map').each(function(){
        var map = initMap( $(this) );
    });
});




let previousStep = 1;


const formStatusCheck = () => {
    const button = document.querySelector('#gform_submit_button_2');

    if(button && !button.dataset.isListener) {
        button.dataset.isListener = true;
        button.addEventListener('click', () => {
            dataLayer.push({
                'event': 'conversionForm-Step', 
                'conversionValue': 'Form Step 7'
            });

            // fbq('trackCustom', 'ConversionFormStep', { 
            //     conversionValue: 'Form Step ' + '7'
            // });\\


            // fbq('track', 'Lead' , { 
            //     conversionValue: '1'
            // });

           
            console.error('event fired: Form Step 7');
        });
    }


    lib.qsa('.--multistep-form').forEach((el) => {
        let hasProgressed = false;
       
        let currentStep = lib.qs('.gf_step_current_page', el).innerHTML;
        let totalSteps = lib.qs('.gf_step_page_count', el).innerHTML;

        // create HTML element
        if(!lib.qs('.progress-tracker-x', el)) {
            let progressContainer = document.createElement('div');
            progressContainer.classList.add('progress-tracker-x');
            progressContainer.classList.add('flex');
            progressContainer.classList.add('justify-end');
            progressContainer.classList.add('text-small');
            progressContainer.innerHTML = currentStep + '/' + totalSteps;


            lib.qs('.gf_progressbar_title', el).parentNode.insertBefore(progressContainer, lib.qs('.gf_progressbar_title', el));
        }

        if(lib.qs('.progress-tracker-x', el)) {
            lib.qs('.progress-tracker-x', el).innerHTML = currentStep + '/' + totalSteps;
        }


        let progressTracker = lib.qsa('.progress-tracker li', el);

        // Check if CurrentStep is more than
        // Previous Step
        if(currentStep > previousStep) {
            hasProgressed = true;
            previousStep = currentStep;
        }

        //  GTM Configuration
        //  * Trigger Configuration -> Custom Event -> Rejex Matching
        //  * If Rejex Matches then 
        //  * Variable name: conversionForm-Step
        //  * Event name: conversionForm-Step
        //  * This trigger fires on: All Custom Events

        // If hasProgressed is true then
        // Push DataLayer to Tag Manager
        if(hasProgressed) {
            // Tag Manager Data Layer Push
            dataLayer.push(
                {
                    'event': 'conversionForm-Step', 
                    'conversionValue' : 'Form Step ' + currentStep
                }
            );


            // fbq('track', 'Lead' , { 
            //     conversionValue: 'Form Step ' + currentStep 
            // });

            console.error('event fired: Form Step ' + currentStep); // Event Fire Debug
            hasProgressed = false;
        }

        progressTracker.forEach((li, index) => {
            li.classList.remove('active');

            if(index == (currentStep - 1)) {
                li.classList.add('active');
            }
        });
    })
}

setInterval(formStatusCheck, 200);




lib.qsa('a[href="#gform_wrapper_2"]').forEach((el) => {
    el.addEventListener('click', (e) => {

        // e.preventDefault();
        let wrapper = lib.qs('.--multistep-form');
        let form = lib.qs('.--multistep-form');

    
     

        setTimeout(() => {
            wrapper.classList.add('active');
            form.scrollIntoView({ behavior: "smooth", block : "end" });
        }, 500);

        setTimeout(() => {
            wrapper.classList.remove('active');
        }, 2500);
    });
});
